const consoled = {};
export const consoledOnce = (consoleType, ...args) => {
    const consoledKey = JSON.stringify({
        consoleType,
        args,
    });
    if (consoled[consoledKey])
        return;
    consoled[consoledKey] = true;
    // eslint-disable-next-line no-console
    console[consoleType](...args);
};
